import { Button, IconButton, Stack, TextField, Typography } from '@mui/material';
import { IDetectedBarcode } from '@yudiel/react-qr-scanner';
import { QRCode01, SearchLG } from 'untitledui-js-base';
import { AccidentScanQrDialog } from './AccidentScanQrDialog';

interface AccidentOrvScanFieldsProps {
  technicalIdNumber?: string;
  onTechnicalIdChange?: (value: string) => void;
  openScanner: boolean;
  openScannerClick?: () => void;
  closeScannerClick: () => void;
  onGetCarClick?: () => void;
  isLoadingCarData?: boolean;
  onScan: (value: IDetectedBarcode[]) => void;
  compact?: boolean;
}
export const AccidentOrvScanFields = ({
  technicalIdNumber,
  onTechnicalIdChange,
  openScanner,
  openScannerClick,
  onGetCarClick,
  isLoadingCarData,
  closeScannerClick,
  onScan,
  compact = false
}: AccidentOrvScanFieldsProps) => (
  <Stack direction="row" pb={2} gap={3}>
    <TextField
      value={technicalIdNumber}
      onChange={(e) => onTechnicalIdChange?.(e.target.value)}
      label="Číslo ORV"
      color="secondary"
      helperText="Zadejte nebo nascenujte ORV číslo"
      InputLabelProps={{ shrink: true }}
      slotProps={{
        input: {
          endAdornment: (
            <IconButton onClick={openScannerClick} color="info" sx={{ height: '50px', width: '50px' }}>
              <QRCode01 />
            </IconButton>
          )
        }
      }}
    />
    <Button
      variant="contained"
      onClick={onGetCarClick}
      startIcon={<SearchLG />}
      color="info"
      sx={{ height: '55px' }}
      loading={isLoadingCarData}
    >
      {!compact && (
        <Typography component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
          Načíst data
        </Typography>
      )}
    </Button>
    <AccidentScanQrDialog onScan={onScan} open={openScanner} onClose={closeScannerClick} />
  </Stack>
);
